import React, { CSSProperties } from "react";

import styles from "./Icon.module.scss";
import { IconClassNames } from "./Icons.type";

export interface IIconProps {
    name: IconClassNames;
    size?: keyof typeof IconSizeMapping;
    color?: string;
    style?: CSSProperties;
    className?: string;
}

const IconSizeMapping = {
    "16": "0.825rem",
    "18": "1.125rem",
    "24": "1.5rem",
    "32": "2rem",
    "48": "4.8rem",
} as const;

export const Icon: React.FC<IIconProps> = ({
    name,
    size = "18",
    color = "var(--formant-color-primary-white)",
    style,
    className,
}) => {
    if (!name) {
        return null;
    }

    const fontSize = IconSizeMapping[size];
    const mergedStyle: CSSProperties = {
        fontSize,
        color,
        ...style,
    };

    return (
        <i
            className={`icon ${className} ${styles[name]}`}
            style={mergedStyle}
            aria-hidden="true"
        />
    );
};
